import { render, staticRenderFns } from "./ButtonBar.vue?vue&type=template&id=c836bddc&scoped=true&"
import script from "./ButtonBar.vue?vue&type=script&lang=js&"
export * from "./ButtonBar.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBar.vue?vue&type=style&index=0&id=c836bddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c836bddc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardText,VIcon,VSpacer,VTooltip})
